import { HeadingContext, useSlottedContext } from "react-aria-components";

import { Heading2 } from "./Heading";

export function CalendarHeading() {
  const { children: title } = useSlottedContext(HeadingContext) ?? {};

  return (
    <Heading2 className="tw:flex-1 tw:text-center tw:text-text-secondary" size={1}>
      {title}
    </Heading2>
  );
}
